var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSylized1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.808594 10.9046C0.808594 4.88216 5.69048 3.24249e-05 11.7135 3.24249e-05C17.7353 3.24249e-05 22.6171 4.88216 22.6171 10.9046C22.6171 16.9269 17.7353 21.809 11.7135 21.809C5.69048 21.809 0.808594 16.9269 0.808594 10.9046Z",
    fill: "#EA731D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5002 8.87557C8.5002 9.62346 8.13942 10.2299 7.6955 10.2299C7.25286 10.2299 6.89209 9.62346 6.89209 8.87557C6.89209 8.12768 7.25286 7.52116 7.6955 7.52116C8.13942 7.52116 8.5002 8.12768 8.5002 8.87557Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5341 8.87557C16.5341 9.62346 16.1746 10.2299 15.7307 10.2299C15.2867 10.2299 14.9272 9.62346 14.9272 8.87557C14.9272 8.12768 15.2867 7.52116 15.7307 7.52116C16.1746 7.52116 16.5341 8.12768 16.5341 8.87557Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.80859 16.4998C8.80859 12.4998 13.8086 10.4997 15.8086 16.5",
    stroke: "black",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSylized1);
export default __webpack_public_path__ + "static/media/sylized_1.aeb9d936c001b6d9bf43e3e7d3415a43.svg";
export { ForwardRef as ReactComponent };